import axios from 'axios';

export const getEventTypeAccess = async (orgId, programId) => {
  const response = await axios.get(
    `/organization/${orgId}/program/${programId}/event-type-access`
  );
  return response.data;
};
